export default __webpack_public_path__ + "images/shapes/dots-bottom-mobile-tall.svg";